import React from 'react';
import PropTypes from 'prop-types';
import './button.css';

const SecondaryButton = ({ onClick, text, icon: IconComponent, width, height, style }) => {
    return (
        <button className="secondary-button" onClick={onClick} style={style}>
            {IconComponent && (
                <IconComponent style={{ width, height }} />
            )}
            {text}
        </button>
    );
};

SecondaryButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    icon: PropTypes.elementType, 
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    style: PropTypes.object
};

SecondaryButton.defaultProps = {
    text: 'Cancel',
    icon: null,
    width: '16px',
    height: '16px',
};

export default SecondaryButton;
